import React from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import Config from '../../../../Config';

function ContactButtons() {
  const phone = window.Config.technicalSupportPhone;
  // In RTL Hebrew, leading * on *5555 can render on the wrong side; show 5555* in text.
  const displayPhone = phone?.startsWith('*') ? `${phone.slice(1)}*` : phone;

  const handleOnOpenWhatsApp = () => {
    const whatsAppLink = `https://wa.me/${Config.whatsAppSelfCare}?force_isolation=true&text=`;
    let win = window.open(whatsAppLink, '_blank');
    win.focus();
  };

  return (
    <div className='contact-buttons-container'>
      <div className='contact-buttons'>
        {/* <div className='whatsapp-button'>
          <BtnSubmit
            className='btn-submit'
            isBusiness={false}
            text={'לנציג אנושי ב-WhatsApp'}
            formid='error-page'
            isDisplayArrows={false}
            isDisplayWhatsAppIcon={true}
            onclick={() => handleOnOpenWhatsApp()}
          />
        </div> */}
        <div className='call-representative-button'>
          <BtnSubmit
            className='btn-submit call-representative'
            isBusiness={false}
            text={`יש לחייג ל-${displayPhone} לנציג שירות`}
            formid='error-page'
            isDisplayArrows={false}
            onclick={() => (window.location = `tel:${phone}`)}
          />
          <span className='call-representative-text'>יש לחייג ל-{displayPhone} לנציג שירות</span>
        </div>
      </div>
    </div>
  );
}

export default ContactButtons;
